import { StatusTypesEnum, TOrderStatus, TOrderStatusType } from 'types/Orders/status';
import { ORDER_STATUS_TYPES } from 'types/orderStatuses';

const StatusTypes: TOrderStatusType[] = [
    {
        id: 0,
        order: 1,
        name: 'Создание заказа',
        color: '#0000A0',
        type: StatusTypesEnum.ORDER_CREATE,
    },
    {
        id: 1,
        order: 2,
        name: 'На согласовании',
        color: '#FFFF00',
        type: StatusTypesEnum.UNDER_APPROVAL,
    },
    {
        id: 2,
        order: 3,
        name: 'Согласовано',
        color: '#DD0000',
        type: StatusTypesEnum.APPROVED,
    },
    {
        id: 3,
        order: 4,
        name: 'Задержка старта',
        color: '#FF8000',
        type: StatusTypesEnum.START_DELAY,
    },
    {
        id: 4,
        order: 5,
        name: 'Отменен',
        color: '#B8AD04',
        type: StatusTypesEnum.CANCELED,
    },
    {
        id: 5,
        order: 6,
        name: 'В работе',
        color: '#008040',
        type: StatusTypesEnum.IN_PROGRESS,
    },
    {
        id: 6,
        order: 7,
        name: 'Ожидание',
        color: '#1649FA',
        type: StatusTypesEnum.WAITING,
    },
    {
        id: 7,
        order: 8,
        name: 'Задержка завершения',
        color: '#D242A0',
        type: StatusTypesEnum.DELAY_COMPLETION,
    },
    {
        id: 8,
        order: 9,
        name: 'Ожидает оплаты',
        color: '#D242A0',
        type: StatusTypesEnum.AWAITING_PAYMENTS,
    },
    {
        id: 9,
        order: 10,
        name: 'Завершен',
        color: '#D242A0',
        type: StatusTypesEnum.COMPLETED,
    },
];

/**
 * Массив ключей (key) статусов заказов, которые могут иметь исполнителей (workerPositions).
 * Используется для отображения кнопки добавления исполнителей в настройках статусов.
 * Содержит значения enum ORDER_STATUS_TYPES, которые соответствуют полю key в TOrderStatus.
 */
export const statusKeysWithPerformers = [
    ORDER_STATUS_TYPES.ORDER_CREATE, // 3 - Необходимо согласовать
    ORDER_STATUS_TYPES.UNDER_APPROVAL, // 1 - На согласовании
    ORDER_STATUS_TYPES.AWAITING_PAYMENTS, // 7 - Ожидает оплаты
];

const Statuses: TOrderStatus[] = [];

export { StatusTypes, Statuses };
